module.exports = __webpack_public_path__ + "assets/play-logo-horizontal-component.3a9e941d.svg";